/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class PanelDetails
{
PanelName : string;
ProjectName : string;
}